import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Translation from "../../../../shared/Translation";
import { wrappedFetch } from '../../../helpers/fetch';

import { setHasMembershipContext, setCheckoutOverlay, setSkipMembership} from '../../../actions/ui';

class BackToListing extends Component {
    constructor(props){
        super(props);
        this.escFunction = this.escFunction.bind(this);
    }
    escFunction(event){
        if(event.key === "Escape") {
            this.goBack(event);
        }
    }
    componentDidMount(){
        document.addEventListener("keydown", this.escFunction, false);
    }
    componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false);
    }
    render() {
        if (this.props.isEmbed) {
          return null;
        }

        return (
            <div className='confirmation__nav'>
                <button className='button--link' onClick={this.props.goBack}><i className="icon-arrow_back" aria-hidden="true"></i> <Translation>{'checkout__back_to_listing'}</Translation></button>
            </div>
        )
    }
}

BackToListing.propTypes = {
    queueOn: PropTypes.bool,
}

const mapStateToProps = state => {
    return {
        isEmbed: !!state?.ui?.isEmbed,
        token: state.reservation?.token,
        secret: state.reservation?.secret,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setCheckoutOverlay,
        setHasMembershipContext,
        setSkipMembership,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BackToListing)
